var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddItinerary2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "2 5 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.369,7.961,10.192,5.784H2.571V19.937H19.99V7.961Zm2.177,7.621H12.369V17.76H10.192V15.582H8.014V13.4h2.177V11.228h2.177V13.4h2.177Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddItinerary2);
export default __webpack_public_path__ + "static/media/add-itinerary2.0010c6c691bc2fc74443fd8e83309ee7.svg";
export { ForwardRef as ReactComponent };